<template>
    <div class="h-full main_out">
        <sidebar class="app-sidebar"></sidebar>
        <navbar class="app-navbar"></navBar>
        <div class="tags-nav-out">
            <tags-nav :value="$route" :list="tagNavList" @input="handleClick"  @on-close="handleCloseTag"></tags-nav>
        </div>
        <app-main class="app-main"></app-main>
    </div>
</template>
<script>
import SideBar from "./components/sidebar.vue";
import NavBar from "./components/navbar.vue";
import AppMain from "./components/appMain.vue";
import tagsNav from "./components/tagsNav.vue";
import routers from '@/router.js'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { routeEqual } from '@/utils/index.js'
import { 
    getNewTagList
} from '@/utils/index.js'

export default {
    name: "layout",
    components: {
        "sidebar": SideBar,
        "navbar": NavBar,
        "app-main": AppMain,
        "tags-nav":tagsNav
    },
    computed:{
        tagNavList () {
            return this.$store.state.tagNavList
        },
    },
    watch:{
        '$route'(newRoute){
            // console.log(this.tagNavList)
            // let index = this.tagNavList.findIndex(item => item.name==newRoute.name)
            // if(index==-1){
                const { name, query, params, meta } = newRoute
                this.addTag({
                    route: { name, query, params, meta },
                    type: 'push'
                })
            // }


            
            // this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
        }
    },
    data(){
        return {
            
        }
    },
    mounted(){
        this.setTagNavList()
        // this.addTag({
        //     route: {"name":"首页","params":{},"query":{},"meta":{"hideInMenu":true,"title":"首页","notCache":true,"icon":"ios-home"}}
        // })
        // this.setHomeRoute(routers.options.routes)
        const { name, params, query, meta } = this.$route
        this.addTag({
            route: { name, params, query, meta }
        })
    },
    methods:{
        ...mapMutations([
            'addTag',
            'setTagNavList',
            'setHomeRoute',
            'closeTag'
        ]),
        turnToPage (route) {
            let { name, params, query } = {}
            if (typeof route === 'string') name = route
            else {
                name = route.name
                params = route.params
                query = route.query
            }
            if (name.indexOf('isTurnByHref_') > -1) {
                window.open(name.split('_')[1])
                return
            }
            console.log(query)
            this.$router.push({
                name,
                params,
                query
            })
        },
        handleClick(item){
            this.turnToPage(item)
        },
        handleCloseTag (res, type, route) {
            if (type !== 'others') {
                if (type === 'all') {
                    this.turnToPage('首页')
                } else {
                    if (routeEqual(this.$route, route)) {
                        this.closeTag(route)
                    }
                }
            }
            this.setTagNavList(res)
        },
    }
};
</script>
<style>
.app-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 14rem;
    /* width: 15rem; */
    background-color:#384B69;
    z-index: 100;
}

.app-navbar {
    position: fixed;
    left: 14rem;
    /* left: 15rem; */
    top: 0;
    right: 0;
    bottom: 0;
    height: 3.5rem;
    background-color: #fff;
    z-index: 10;
}
.tags-nav-out{
    background: #f0f0f0;
    position: fixed;
    left: 14rem;
    /* left: 15rem; */
    top: 3.5rem;
    height: 38px;
    width: calc(100vw - 14rem - 15px);
    /* width: calc(100vw - 15rem - 15px); */
    z-index: 9;
}
.app-main {
    padding-left: 15rem;
    /* padding-left: 16rem; */
    padding-top: calc(4.5rem + 38px);
    padding-right:1rem;
}
@keyframes fade-in {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
.main_out{
  animation-name: fade-in;
  animation-duration: 1s;
  animation-timing-function: normal;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: none;
}
</style>
